import { render } from "./CometChatSmartReplyPreview.vue?vue&type=template&id=7163329e"
import script from "./CometChatSmartReplyPreview.vue?vue&type=script&lang=js"
export * from "./CometChatSmartReplyPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__